<template>
    <v-app>
        <p>No tiene acceso a esta página, debe loguearse primero.</p>
    </v-app>
</template>
<script>
export default {
  name: 'AccesoInvalido',
};
</script>
